import { Box, HStack, Skeleton, SkeletonText, VStack } from "@chakra-ui/react"

const FeedCardSkeleton = () => (
  <Box
    borderWidth="1px"
    borderRadius="md"
    padding={4}
    shadow="sm"
    width="full"
    _hover={{ shadow: "md" }}
  >
    <HStack gap={4} align="start">
      <Skeleton width="180px" height="100px" borderRadius="md" flexShrink={0} />
      <VStack align="start" gap={2} flex="1">
        <Skeleton height="16px" width="60%" />
        <SkeletonText lineClamp="3" gap="2" width="100%" />
      </VStack>
    </HStack>
  </Box>
)

const FeedCardSkeletonList = ({ count = 3 }: { count?: number }) => {
  return (
    <VStack gap={4} align="stretch">
      {Array.from({ length: count }).map((_, i) => (
        <FeedCardSkeleton key={i} />
      ))}
    </VStack>
  )
}

export default FeedCardSkeletonList
